var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVerified = function SvgVerified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#verified_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00BE7A",
    d: "m7.8 21.04-1.82-3.11-3.616-.748.416-3.512L.49 11l2.29-2.653-.416-3.519 3.623-.736L7.795.961l3.21 1.475L14.212.96l1.829 3.131 3.594.736-.416 3.52L21.51 11l-2.29 2.67.416 3.512-3.593.749-1.83 3.108L11 19.568zm.796-2.368 2.402-1.026 2.471 1.026 1.51-2.253 2.629-.674-.262-2.69 1.804-2.056-1.804-2.101.262-2.689-2.63-.628-1.55-2.253-2.426 1.024-2.471-1.024-1.506 2.256-2.62.62.25 2.694L2.85 11l1.804 2.057-.249 2.74 2.618.62zm1.419-4.52 5.305-5.26-1.148-1.044-4.157 4.126L7.85 9.692 6.68 10.84z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "verified_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
};
export default SvgVerified;